module.exports = __webpack_public_path__ + "static/media/edit-profile-icon.8c5bbbf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/edit-profile-icon.svg
// module id = 775
// module chunks = 0